export const ADMIN_SESSION_CACHE_KEYS = {
  token: 'kesai:admin:token',
  user: 'kesai:admin:user',
  tabs: 'kesai:admin:tabs'
} as const

export const ADMIN_PREFERENCE_CACHE_KEYS = {
  sidebarCollapsed: 'kesai:admin:sidebar-collapsed',
  tenantCode: 'kesai:admin:tenant-code',
  locale: 'kesai:admin:locale'
} as const

/** Portal 现行兼容键；Admin 基础设施禁止读取、写入或清理。 */
export const PORTAL_LEGACY_SESSION_CACHE_KEYS = {
  token: 'token',
  user: 'userInfo'
} as const
